import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { getInnerHeight } from '../../helpers/device'
import EventEmitter, { SCROLL } from '../../helpers/EventEmitter'
import { Dropdown, positionDropdown } from '../dropdown'
import { HandleClickOutside } from '../HandleClickOutside'
import DateRange from './DateRange'
import './i18n'

const HEIGHT_CALENDAR = 350

const InputDateRange = ({
  children,
  onSubmit,
  defaultStartDate,
  defaultEndDate,
  keyInput,
  minDate,
  maxDate,
  scrollId,
}) => {
  const inputRef = useRef()

  const [isOpen, setIsOpen] = useState(false)
  const [position, setPosition] = useState(positionDropdown.BOTTOM_START_RIGHT)

  useEffect(() => {
    const eventAction = (data) => {
      if (!data || !scrollId) return
      if (data === scrollId) {
        setIsOpen(false)
      }
    }

    EventEmitter.subscribe(SCROLL, eventAction)
    return () => {
      EventEmitter.unsubscribe(SCROLL, eventAction)
    }
  }, [])

  const onClick = () => {
    setPosition(
      getInnerHeight() - inputRef.current.getBoundingClientRect().bottom <
        HEIGHT_CALENDAR
        ? positionDropdown.TOP_START_RIGHT
        : positionDropdown.BOTTOM_START_RIGHT,
    )
    setIsOpen(true)
  }

  const clickOutside = () => setIsOpen(false)

  const submit = (date) => {
    setIsOpen(false)
    onSubmit(date)
  }

  return (
    <>
      <div onClick={onClick} ref={inputRef}>
        {children}
      </div>
      {isOpen && (
        <Dropdown parentRef={inputRef} position={position}>
          <HandleClickOutside
            handleClickOutside={clickOutside}
            exceptRef={inputRef}
          >
            <DateRange
              defaultStartDate={defaultStartDate}
              defaultEndDate={defaultEndDate}
              keyInput={keyInput}
              onSubmit={submit}
              minDate={minDate}
              maxDate={maxDate}
            />
          </HandleClickOutside>
        </Dropdown>
      )}
    </>
  )
}

InputDateRange.propTypes = {
  children: PropTypes.node.isRequired,
  onSubmit: PropTypes.func.isRequired,
  defaultStartDate: PropTypes.any,
  defaultEndDate: PropTypes.any,
  keyInput: PropTypes.string,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
}

InputDateRange.defaultProps = {
  defaultStartDate: new Date(),
  defaultEndDate: new Date(),
  minDate: new Date(1950, 0, 1),
  maxDate: new Date(2050, 0, 0),
  keyInput: 'selection',
}

export default InputDateRange
